import {
  Cohort,
  ProcessingKey,
  VC_COHORTS,
} from 'nove8/constants/root-constants'
import { createCohortLead } from 'nove8/helpers/api/createCohortLead'
import { createLead } from 'nove8/helpers/api/createLead'
import { fetchLead } from 'nove8/helpers/api/fetchLead'
import { useZustandStore } from 'zustandGlobalStore'
import { getUserHasChat } from './getUserHasChat'

export const getFirstLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.GET_FIRST_LEAD)

  const searchParams = new URLSearchParams(window.location.search)
  const leadIdFromUrl = searchParams.get('uuid')
  const tokenFromUrl = searchParams.get('token')

  const leadIdFromStore = useZustandStore.getState().lead?.id
  const leadId = leadIdFromUrl || leadIdFromStore
  const initialCohort = useZustandStore.getState().initialCohort

  if (VC_COHORTS.includes(initialCohort as Cohort)) {
    await getUserHasChat(tokenFromUrl || '')
  }

  if (leadId) {
    await fetchLead(leadId)

    const cohort = useZustandStore.getState().lead?.cohort

    if (initialCohort !== cohort) {
      await createCohortLead()
    }

    useZustandStore.getState().stopProcessing(ProcessingKey.GET_FIRST_LEAD)
    return
  }

  await createLead()

  useZustandStore.getState().stopProcessing(ProcessingKey.GET_FIRST_LEAD)
}
